var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.84 205.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e261a;}.cls-2{fill:#c3d600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.62,205.49H0V192.65H7.33V195H2.86v2.86H7v2.35H2.86v2.93H7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.06,205.49H21.17l-5.23-8.07c-.31-.47-.52-.83-.64-1.06h0c.05.45.07,1.14.07,2.07v7.06h-2.7V192.65h3.08l5.05,7.81q.34.54.63,1h0a13.32,13.32,0,0,1-.07-1.76v-7.1h2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.93,200.39a5.91,5.91,0,0,1-1.18,4,4.29,4.29,0,0,1-3.43,1.37,4.87,4.87,0,0,1-1.85-.35v-2.71a2.67,2.67,0,0,0,1.65.56c1.3,0,2-1,2-2.93v-7.63h2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.89,205.71a5.88,5.88,0,0,1-4.44-1.79,6.48,6.48,0,0,1-1.72-4.68,6.94,6.94,0,0,1,1.74-4.92,6,6,0,0,1,4.63-1.88,5.74,5.74,0,0,1,4.4,1.8A6.65,6.65,0,0,1,52.18,199a6.84,6.84,0,0,1-1.74,4.88A6,6,0,0,1,45.89,205.71ZM46,194.92a2.84,2.84,0,0,0-2.39,1.15,4.78,4.78,0,0,0-.89,3,4.69,4.69,0,0,0,.89,3A2.82,2.82,0,0,0,46,203.21a2.87,2.87,0,0,0,2.35-1.08,4.67,4.67,0,0,0,.86-3,5.07,5.07,0,0,0-.84-3.11A2.73,2.73,0,0,0,46,194.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.09,192.65,62,200.92v4.57H59.09V201l-4-8.32h3.27l2,4.79c0,.09.13.44.29,1.05h0a5.25,5.25,0,0,1,.27-1l2.09-4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.9,205.49H78.34V192.65H81.2v10.49h4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.76,192.65v2.24H93.7v8.36h1.06v2.24h-5v-2.24h1.07v-8.36H89.77v-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.07,195h-4.48v3.16h4.12v2.34h-4.12v5H99.72V192.65h7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.49,205.49h-7.62V192.65h7.33V195h-4.47v2.86h4.16v2.35h-4.16v2.93h4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.45,205a8.33,8.33,0,0,1-3.63.68,6.09,6.09,0,0,1-4.6-1.74,6.35,6.35,0,0,1-1.67-4.62,6.8,6.8,0,0,1,1.88-5,6.54,6.54,0,0,1,4.89-1.91,8.93,8.93,0,0,1,3.13.47v2.78a5.54,5.54,0,0,0-2.9-.77,3.82,3.82,0,0,0-2.89,1.14,4.27,4.27,0,0,0-1.1,3.08,4.18,4.18,0,0,0,1,3,3.66,3.66,0,0,0,2.79,1.1,5.87,5.87,0,0,0,3.06-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.16,205.49h-7.57V192.65h2.86v10.49h4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.77,199.93q0,5.77-5.34,5.78-5.18,0-5.17-5.65v-7.41h2.87v7.45c0,2.07.8,3.11,2.41,3.11s2.36-1,2.36-3v-7.56h2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.3,205.49V192.65h4.63a5.73,5.73,0,0,1,3.27.79,2.53,2.53,0,0,1,1.14,2.22,2.63,2.63,0,0,1-.7,1.82,3.66,3.66,0,0,1-1.77,1.08v0a3.49,3.49,0,0,1,2.16,1,2.84,2.84,0,0,1,.81,2,3.44,3.44,0,0,1-1.24,2.79,5.23,5.23,0,0,1-3.42,1Zm2.86-10.71v3h1.26a2.09,2.09,0,0,0,1.4-.43,1.49,1.49,0,0,0,.51-1.19c0-.95-.7-1.42-2.09-1.42Zm0,5.19v3.39h1.55a2.38,2.38,0,0,0,1.56-.47,1.57,1.57,0,0,0,.56-1.27,1.46,1.46,0,0,0-.55-1.21,2.46,2.46,0,0,0-1.55-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93,80.57,33.46,36.8a7.54,7.54,0,0,0-8.93,12.14L84.05,92.71A7.54,7.54,0,0,0,93,80.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.73,45.24,95.21,1.47a7.54,7.54,0,1,0-8.93,12.14L145.8,57.38a7.54,7.54,0,0,0,8.93-12.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.87,62.8,66.35,19a7.53,7.53,0,1,0-8.92,12.14L117,74.94a7.53,7.53,0,1,0,8.92-12.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.43,169.21,26.91,125.44A7.53,7.53,0,1,0,18,137.58L77.5,181.35a7.54,7.54,0,1,0,8.93-12.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.91,61.09v70.42a7.54,7.54,0,0,0,15.07,0V61.09a7.54,7.54,0,0,0-15.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.48,103.84v70.41a7.54,7.54,0,0,0,15.07,0V103.84a7.54,7.54,0,1,0-15.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.23,68.87V89.59a7.54,7.54,0,1,0,15.07,0V68.87a7.54,7.54,0,1,0-15.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.23,127.58v11.48a7.54,7.54,0,0,0,15.07,0V127.58a7.54,7.54,0,0,0-15.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.23,68.87V80.35a7.54,7.54,0,0,0,15.07,0V68.87a7.54,7.54,0,1,0-15.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.72,49.22,94.47,14.08A7.53,7.53,0,1,0,87,1L25.27,36.12a7.54,7.54,0,0,0,7.45,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.74,110.55l61.75-35.13A7.54,7.54,0,1,0,157,62.32L95.29,97.45a7.54,7.54,0,0,0,7.45,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.74,180.8l61.75-35.13a7.54,7.54,0,1,0-7.45-13.1L95.29,167.7a7.54,7.54,0,0,0,7.45,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.5,163.72a6.33,6.33,0,1,1,0,12.66,6.33,6.33,0,1,1,0-12.66Zm0,11.41a4.91,4.91,0,0,0,4.91-5.08,4.93,4.93,0,1,0-4.91,5.08Zm-2.42-1.8v-6.4a13.41,13.41,0,0,1,2.35-.2c1.14,0,2.8.2,2.8,1.86a1.62,1.62,0,0,1-1.32,1.49v.11c.63.2.94.72,1.11,1.55a5.61,5.61,0,0,0,.49,1.59h-1.46a5.38,5.38,0,0,1-.48-1.59c-.24-1-.8-1-2.11-1v2.59Zm1.41-3.6c1.08,0,2.25,0,2.25-1,0-.59-.41-1-1.42-1a4.16,4.16,0,0,0-.83.07Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4d5c32b2a573166603530c38ce81a849.svg";
export { ForwardRef as ReactComponent };